import React from "react";
import { COLORS } from "../../../assets/colors";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Box } from "@mui/material";
import { PaginationUI } from "../../Pagination/PaginationUI";
import { CategoriesModal } from "../CategoriesModal";
import { useFetchGet } from "../../../hooks";



const Item = styled(Paper)(({ theme }) => ({
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, rgba(30, 58, 95, 0.95) 100%)`,
    borderRadius: '16px',
    border: '3px solid #d7b547',
    padding: '16px',
    textAlign: 'center',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    height: '100%',
    aspectRatio: '0.75',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.4)',
    [theme.breakpoints.down('sm')]: {
        padding: '12px',
        borderRadius: '12px',
        border: '2px solid #d7b547',
    },
    '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0px 12px 32px rgba(215, 181, 71, 0.4)',
        border: '3px solid #e6c663',
    },
}));

function CategoriesProductsUI({
    propSubCategoryId,
    propSubCategoryName
}) {

    const [open, setOpen] = React.useState(false);
    const [selectedProductIndex, setSelectedProductIndex] = React.useState(null);
    const [currentPage, setCurrentPage] = React.useState(1);
    const handleOpen = (index) => {
        setSelectedProductIndex(index);
        setOpen(true);
    };
    const { data, isLoading } = useFetchGet(`https://app-nuokwylgla-uc.a.run.app/api/v1/products/${propSubCategoryId}?page=${currentPage}`);

    if (!isLoading && data.statusCode === 200) {
        return (
            <div>
                <Box sx={{ paddingBottom: { xs: '50px', sm: '50px', md: '0px', lg: '0px', xl: '0px' } }}>
                    <Grid item xs={12} sx={{ padding: { xs: "20px", sm: "30px 40px", md: "30px 60px", lg: "30px 80px", xl: "30px 100px" } }}>
                        <Grid container spacing={{ xs: 2, sm: 3, md: 3 }}>
                            {
                                data.products.map((product, index) => (
                                    <Grid item key={product.id} xs={6} sm={4} md={3} lg={2.4} xl={2}>
                                        <Item onClick={() => handleOpen(index)}>
                                            <Box sx={{
                                                width: '100%',
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: 'rgba(255, 255, 255, 0.1)',
                                                borderRadius: { xs: '8px', sm: '12px' },
                                                padding: { xs: '6px', sm: '8px' },
                                                overflow: 'hidden'
                                            }}>
                                                <img 
                                                    src={product.image} 
                                                    loading="lazy"
                                                    alt={product.name}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "contain"
                                                    }} 
                                                />
                                            </Box>
                                        </Item>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>

                    <PaginationUI
                        totalPages={data.totalPages}
                        setCurrentPage={setCurrentPage}
                    />
                </Box>
                {selectedProductIndex !== null && (
                    <CategoriesModal
                        open={open}
                        setOpen={setOpen}
                        data={data.products[selectedProductIndex]}
                    />
                )}

            </div>
        );
    }

}

export { CategoriesProductsUI };